import React, { useState, useEffect, useMemo, useCallback } from 'react';
import styles from './styles.module.css';
import { Icon } from 'common/icon';

interface RatingProps {
  value: number;
  totalStars?: number;
  onChange: (rating: number) => void;
  variant: 'streamer' | 'casino';
}

export const Rating = ({
  value,
  totalStars = 5,
  onChange,
  variant,
}: RatingProps) => {
  const [rating, setRating] = useState<number>(value);
  const [hoverRating, setHoverRating] = useState<number>(0);

  useEffect(() => {
    setRating(value);
  }, [value]);

  const handleClick = useCallback(
    (index: number) => {
      setRating(index);
      onChange(index);
    },
    [onChange]
  );

  const handleMouseEnter = (index: number) => {
    setHoverRating(index);
  };

  const handleMouseLeave = () => {
    setHoverRating(0);
  };

  const ratingContent = useMemo(() => {
    switch (variant) {
      case 'casino':
        return (
          <div className={styles.star_container}>
            <div className={styles.star_wrapper}>
              <span className={styles.text}>Rate casino</span>
              <div className={styles.stars}>
                {[...Array(totalStars)].map((_, index) => {
                  const starIndex = index + 1;
                  const isFilled = starIndex <= (hoverRating || rating);
                  const color = isFilled ? '#FFAB09' : '#171717';
                  const fillOpacity = isFilled ? 1 : 0.25;

                  return (
                    <Icon.Star
                      key={starIndex}
                      width="27.6"
                      height="27.6"
                      onClick={() => handleClick(starIndex)}
                      onMouseEnter={() => handleMouseEnter(starIndex)}
                      onMouseLeave={handleMouseLeave}
                      fill={color}
                      fillOpacity={fillOpacity}
                      cursorPointer
                    />
                  );
                })}
              </div>
            </div>
          </div>
        );
      case 'streamer':
      default:
        return (
          <div className={styles.container}>
            {[...Array(totalStars)].map((_, index) => {
              const starIndex = index + 1;
              const isFilled = starIndex <= (hoverRating || rating);
              const color = isFilled ? '#ffd700' : '#fff';
              const fillOpacity = isFilled ? 1 : 0.25;

              return (
                <Icon.Star
                  key={starIndex}
                  width="27.6"
                  height="27.6"
                  onClick={() => handleClick(starIndex)}
                  onMouseEnter={() => handleMouseEnter(starIndex)}
                  onMouseLeave={handleMouseLeave}
                  fill={color}
                  fillOpacity={fillOpacity}
                  cursorPointer
                />
              );
            })}
          </div>
        );
    }
  }, [handleClick, hoverRating, rating, totalStars, variant]);

  return ratingContent;
};
